import HttpRequest from '../../lib/HttpRequest'

const api = new HttpRequest('storage')
const getters = {
  base () {
    return api.getEndpoint()
  }
}

export default getters
